<div class="verification-edit-dialog" [formGroup]="form">
  <div class="verification-edit-dialog__header">
    <div>
      <h2>Edycja zgłoszonych zmian</h2>
      <p>
        Edytujesz wyłącznie pola zgłoszone przez Agenta. Po zapisaniu administrator zatwierdza finalną wersję zmian.
      </p>
    </div>

    <button
      mat-icon-button
      type="button"
      [disabled]="processingRequest"
      (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="verification-edit-dialog__content">
    <div class="verification-fields" *ngIf="fields.length > 0; else noFields">
      <mat-card
        class="verification-field-card"
        *ngFor="let field of fields"
      >
        <h3>{{ field.label }}</h3>

        <div class="verification-field-grid">
          <div class="verification-field-preview">
            <h4>Aktualna wartość</h4>

            <ng-container [ngSwitch]="field.type">
              <div *ngSwitchCase="'openHours'" class="opening-hours-preview">
                <div
                  class="opening-hours-preview__row"
                  *ngFor="let item of formatOpeningHours(getPreviousValue(field.key))"
                >
                  <span class="opening-hours-preview__day">{{ item.label }}</span>
                  <span
                    class="opening-hours-preview__time"
                    [class.opening-hours-preview__time--closed]="item.closed">
                    {{ item.closed ? 'Nieczynne' : item.openTime + ' - ' + item.closeTime }}
                  </span>
                </div>

                <span *ngIf="formatOpeningHours(getPreviousValue(field.key)).length === 0">—</span>
              </div>

              <div *ngSwitchCase="'images'" class="verification-images">
                <ng-container *ngFor="let image of asImages(getPreviousValue(field.key))">
                  <div class="verification-image">
                    <img
                      *ngIf="image.location"
                      [src]="getImageUrl(image.location)"
                      alt="Aktualne zdjęcie">
                  </div>
                </ng-container>

                <span *ngIf="asImages(getPreviousValue(field.key)).length === 0">—</span>
              </div>

              <span *ngSwitchDefault [innerHTML]="formatValue(getPreviousValue(field.key))"></span>
            </ng-container>
          </div>

          <div class="verification-field-edit">
            <h4>Wartość do zatwierdzenia</h4>

            <ng-container [ngSwitch]="field.type">
              <div *ngSwitchCase="'editor'" class="editor-field">
                <angular-editor
                  [formControlName]="field.key"
                  [config]="editorConfig">
                </angular-editor>
              </div>

              <mat-form-field *ngSwitchCase="'textarea'" class="w-full">
                <mat-label>{{ field.label }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="field.key">
                </textarea>
              </mat-form-field>

              <mat-checkbox
                *ngSwitchCase="'boolean'"
                [formControlName]="field.key">
                {{ field.label }}
              </mat-checkbox>

              <div *ngSwitchCase="'openHours'" [formGroupName]="field.key">
                <div
                  *ngFor="let day of openingHoursDays"
                  [formGroupName]="day.key"
                  class="opening-hours-edit-row"
                  fxLayout="row"
                  fxLayoutGap="15px"
                  fxLayoutAlign="start center"
                  fxLayout.lt-md="column"
                >
                  <div fxFlex="25">
                    <strong>{{ day.label }}</strong>
                  </div>

                  <mat-checkbox
                    fxFlex="20"
                    formControlName="closed"
                    (change)="onClosedChange(day.key)">
                    Nieczynne
                  </mat-checkbox>

                  <mat-form-field fxFlex="25">
                    <mat-label>Otwarcie</mat-label>
                    <input matInput type="time" formControlName="openTime">
                  </mat-form-field>

                  <mat-form-field fxFlex="25">
                    <mat-label>Zamknięcie</mat-label>
                    <input matInput type="time" formControlName="closeTime">
                  </mat-form-field>
                </div>
              </div>

              <div *ngSwitchCase="'daysOffFromWork'">
                <div fxLayout="column" fxLayoutGap="15px">
                  <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
                    <app-datepicker
                      fxFlex="70"
                      label="Pojedynczy dzień nieobecności"
                      placeholder="YYYY-MM-DD"
                      [control]="dayOffDateControl">
                    </app-datepicker>

                    <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center">
                      <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        (click)="addSingleDayOff()">
                        <mat-icon>add</mat-icon>
                        <span>Dodaj dzień</span>
                      </button>
                    </div>
                  </div>

                  <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
                    <app-datepicker
                      fxFlex="35"
                      label="Nieobecność od"
                      placeholder="YYYY-MM-DD"
                      [control]="dayOffDateFromControl">
                    </app-datepicker>

                    <app-datepicker
                      fxFlex="35"
                      label="Nieobecność do"
                      placeholder="YYYY-MM-DD"
                      [control]="dayOffDateToControl">
                    </app-datepicker>

                    <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center">
                      <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        (click)="addDayOffRange()">
                        <mat-icon>date_range</mat-icon>
                        <span>Dodaj zakres</span>
                      </button>
                    </div>
                  </div>

                  <div
                    *ngIf="daysOffFromWorkArray.length > 0; else noDaysOff"
                    fxLayout="row wrap"
                    fxLayoutGap="8px"
                    class="days-off-list">
                    <mat-chip
                      *ngFor="let control of daysOffFromWorkArray.controls; let i = index"
                      [removable]="true"
                      (removed)="removeDayOff(i)">
                      {{ control.value }}

                      <button matChipRemove type="button">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip>
                  </div>

                  <ng-template #noDaysOff>
                    <div class="empty-state">
                      Brak zaplanowanych nieobecności
                    </div>
                  </ng-template>
                </div>
              </div>

              <app-sub-category-dobry-agent-select
                *ngSwitchCase="'subCategories'"
                label="Podkategorie"
                [formControlName]="field.key">
              </app-sub-category-dobry-agent-select>

              <app-payment-method-dobry-agent-select
                *ngSwitchCase="'paymentMethods'"
                label="Metody płatności"
                [formControlName]="field.key">
              </app-payment-method-dobry-agent-select>

              <app-insurance-company-dobry-agent-select
                *ngSwitchCase="'insuranceCompanies'"
                label="Towarzystwa ubezpieczeniowe"
                [formControlName]="field.key">
              </app-insurance-company-dobry-agent-select>

              <app-image-drag-and-drop
                *ngSwitchCase="'images'"
                [formControlName]="field.key"
                [baseUrl]="dobryAgentBaseUrl"
                [maxSize]="3 * 1024 * 1024"
                [maxTotalSize]="8 * 1024 * 1024">
              </app-image-drag-and-drop>

              <mat-form-field *ngSwitchDefault class="w-full">
                <mat-label>{{ field.label }}</mat-label>
                <input matInput [formControlName]="field.key">

                <mat-error *ngIf="form.get(field.key)?.hasError('email')">
                  Nieprawidłowy adres email
                </mat-error>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </mat-card>
    </div>

    <ng-template #noFields>
      <div class="empty-state">
        Brak pól do edycji.
      </div>
    </ng-template>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="verification-edit-dialog__actions">
    <button
      mat-stroked-button
      color="warn"
      type="button"
      [disabled]="processingRequest"
      (click)="cancel()">
      Anuluj
    </button>

    <button
      mat-flat-button
      color="accent"
      type="button"
      [disabled]="processingRequest || fields.length === 0"
      [class.spinner]="processingRequest"
      (click)="saveAndAccept()">
      Zapisz i zaakceptuj
    </button>
  </mat-dialog-actions>
</div>
